// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3iA0R","vLegacy":"SelectSecondary_vLegacy__2aum8","error":"SelectSecondary_error__38tYT","disabled":"SelectSecondary_disabled__1FOa5"};